module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-2560ca5e0751b6042cdb020649f843fe.svg";